import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getReadyForYouData } from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  recipes: [] as any,
  filteredData: [] as any,
  servingSize: [] as any,
  selectedRoast: null as any,
};

const GetReadyForYouDataSlice = createSlice({
  name: "GetReadyForYouData",
  initialState,
  reducers: {
    sortRecipe(state, action) {
      const recipes = [...action.payload.recipes]; // Create a shallow copy to avoid mutating state directly
      if (action.payload.sort === "a-z") {
        recipes.sort((a: any, b: any) => a.title.localeCompare(b.title));
      } else if (action.payload.sort === "z-a") {
        recipes.sort((a: any, b: any) => b.title.localeCompare(a.title));
      } else if (action.payload.sort == "newest-date") {
        recipes.sort(
          (a: any, b: any) =>
            new Date(b.postDategmt).getTime() -
            new Date(a.postDategmt).getTime()
        );
      } else if (action.payload.sort == "oldest-date") {
        recipes.sort(
          (a: any, b: any) =>
            new Date(a.postDategmt).getTime() -
            new Date(b.postDategmt).getTime()
        );
      }
      state.recipes = recipes;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReadyForYouData.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      getReadyForYouData.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        state.recipes = action.payload.data?.readyForYouModelList?.items.sort(
          (a: any, b: any) =>
            new Date(a.postDategmt).getTime() -
            new Date(b.postDategmt).getTime()
        );
      }
    );
    builder.addCase(getReadyForYouData.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});
export const { sortRecipe } = GetReadyForYouDataSlice.actions;
export const getReadyForYouDataSlice = GetReadyForYouDataSlice.reducer;
